var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.lazy)?_c('img',{staticClass:"ym-image-component",attrs:{"src":_vm.source,"alt":_vm.alt},on:{"click":_vm.handleClick}}):_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.source),expression:"source"}],attrs:{"alt":_vm.alt}})}
var staticRenderFns = []

export { render, staticRenderFns }